import { Outlet } from "react-router-dom";
import Navigation from "@/components/new-landing/Navigation";
import Footer from "@/components/new-landing/Footer";

const MarketingLayout = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <Outlet />
      <Footer />
    </div>
  );
};

export default MarketingLayout;
